module.exports = require("./fo-FO");